import { useState, useEffect, useCallback } from 'react';

const useTimer = (initialTimeSec, intervalMs = 1000) => {
  const [time, setTime] = useState(initialTimeSec * 1000);
  const [initialTime, setInitialTime] = useState(initialTimeSec * 1000);
  const [isRunning, setIsRunning] = useState(false);

  useEffect(() => {
    let timer;

    if (isRunning) {
      timer = setInterval(() => {
        setTime((prevTime) => {
          const nextTime = prevTime - intervalMs;

          if (nextTime <= 0) {
            setIsRunning(false);
            return 0;
          }

          return nextTime;
        });
      }, intervalMs);
    }

    return () => {
      clearInterval(timer);
    };
  }, [isRunning, intervalMs, initialTimeSec]);

  const startTimer = useCallback(() => {
    setInitialTime(initialTimeSec * 1000);
    setTime(initialTimeSec * 1000);
    setIsRunning(true);
  }, [initialTimeSec]);

  const stopTimer = useCallback(() => {
    setIsRunning(false);
  }, []);

  const resetTimer = useCallback(() => {
    setIsRunning(false);
    setInitialTime(initialTimeSec * 1000);
    setTime(initialTimeSec * 1000);
  }, [initialTimeSec]);

  return {
    time: {
      minutes: Math.floor(time / 60000),
      seconds: Math.ceil((time % 60000) / 1000),
    },
    isRunning,
    startTimer,
    stopTimer,
    resetTimer,
  };
};

export default useTimer;